export default __webpack_public_path__ + "static/media/MicrosoftTeams-image2.751164ec.png";